import CalendlyStatusOnWebp from "../../../assets/images/calendly-on.webp"
import CalendlyStatusOnPng from "../../../assets/images/calendly-on.png"
import CalendlyStatusOffWebp from "../../../assets/images/calendly-off.webp"
import CalendlyStatusOffPng from "../../../assets/images/calendly-off.png"

interface Props {
  on: boolean
}

const CalendlyStatus = ({ on }: Props) => (
  <>
    <picture>
      <source
        srcSet={on ? CalendlyStatusOnWebp : CalendlyStatusOffWebp}
        type="image/webp"
      />
      <img
        width={102}
        height={33}
        src={on ? CalendlyStatusOnPng : CalendlyStatusOffPng}
        alt="calendly integration status indicator"
      />
    </picture>
    <span role="status" aria-live="polite" className="sr-only">
      {on ? "Calendly integration is on" : "Calendly integration is off"}
    </span>
  </>
)

export default CalendlyStatus
